<template>
  <el-dialog
    class="modal-modify-user"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <el-scrollbar style="569px;">
      <div class="content">
        <el-form
            style="height:555px;"
            v-loading="isLoading"
            label-position="top"
            :model="formData"
            class="user-modify__form"
         >
            <el-form-item label="已绑定授权的账号:">
              <div class="systems-config">
                <el-table
                    ref="tableList"
                    :data="dataList"
                    v-loading="isLoading"
                    border
                    stripe
                    tooltip-effect="dark"
                   >
                      <el-table-column label="操作项目" width="120" :resizable="false">
                        <template slot-scope="scope">
                          <el-button
                              :disabled="scope.row.authStatus=='invalid' || scope.row.authStatus=='expired' || scope.row.authStatus=='unBind'"
                              @click="$_emptyApplication(scope.row.accountName,scope.row.merchantId,scope.row.uid)"
                              class="cancelApplication"
                          >解除授权</el-button>
                        </template>
                      </el-table-column>

                      <el-table-column
                        v-for="column in columns"
                        :key="column.key"
                        :prop="column.key"
                        :label="column.label"
                        :width="column.width"
                        sortable
                        show-overflow-tooltip
                        filter-placement="bottom"
                        v-if="!column.component"
                    > </el-table-column>

                    <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
                      <template slot-scope="scope">
                        <component :is="column.component" :row="scope.row" :tag="column.key"></component>
                      </template>
                    </el-table-column>

                  <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
                </el-table>
              </div>
            </el-form-item>
        </el-form>
      </div>
    </el-scrollbar>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getAccounts"
      ></cd-pagination>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";

const columns = [
  { key: "merchantId", label: "商家编号", width: 120 },
  { key: "accountName", label: "账号", width: 120 },
  { key: "authStatus", label: "授权状态", width: 120, component: "statues"},
  { key: "authMsg", label: "授权内容", width: 120 },
  { key: "authStartTime", label: "授权时间" ,width: 160 },
  { key: "authEndTime", label: "有效时间" },
];
export default {
  name: "modal-config-accountlist",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    userData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: true,
      formData: {},
      dataList: [],
      columns,
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      }
    };
  },
  methods: {
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    //获取列表 修改两个字段
    $_getAccounts() {
      this.isLoading = true;
      this.$service
        .post("getThirdPartyAccount", {
          uid: this.userData.uid,
          appId: this.userData.appId,
          startCreateDate: "",
          endCreateDate: "",
          pageNow: 1,
          pageSize: 9999
        })
        .then(result => {
          if (result.$.checkResult(result, true)) {
            this.isLoading = true;
            this.pagination.pages = result.data.pages;
            this.pagination.total = result.data.total;
            this.dataList = result.data.rows.concat([]);
          }
          this.isLoading = false;
        });
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getAccounts();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getAccounts();
    },
    //清空账号 
    $_emptyApplication(accountName,merchantId,uid) {
      const self = this;
      $MessageBox.confirm({
        content: `
         解除当前账号的授权关系？
        `,
        onOk() {
          self.$service
            .post("unbindThirdPartyAccount", {
              uid: uid,
              appId: self.userData.appId,
              accountName: accountName,
              merchantId: merchantId,
            })
            .then(result => {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.$_getAccounts();
                }
              });
            });
        }
      });
    }
  },
  created() {},
  mounted() {
    this.visible = true;
    this.$_getAccounts();
  },
  components: {
    statues: {
      template: `<span>{{row.authStatus === "authorized" ? '已经授权':row.authStatus === "expired" ? '已经过期':"已经失效" }}</span>`,
      props: { row: { type: Object, require: true } }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: {
    left: 30px;
    top: 24px;
    right: 30px;
    bottom: 20px;
  }
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
  }
}
/deep/ .cd-pagination .pagination-info {
  position: absolute;
  top: 0px;
  right: 30px;
  height: 44px;
  line-height: 44px;
}
//滚动条
/deep/ .el-scrollbar {
  position: relative;
  &:active,
  &:focus,
  &:hover {
    .el-scrollbar__bar {
      opacity: 1;
      transition: opacity 340ms ease-out;
      border-radius: 0;
    }
  }
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  max-height: 569px;
}
/deep/ .el-scrollbar__bar.is-vertical {
  width: 0px;
  height: 0px;
}
.cancelApplication {
  background-color: #1895dd;
  padding: 1px 6px;
  width: 80px;
  height: 30px;
}
 .cancelApplication:disabled {
    background-color: #ccc;  
}
/deep/ .el-form-item__content{
border:1px solid #eee;
}
</style>

